/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Kullanim_S4_I3Inputs */

const tr_kullanim_s4_i3 = /** @type {(inputs: Kullanim_S4_I3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hesap giriş bilgilerinin gizliliğinden Kullanıcı sorumludur; bu bilgilerle yapılan işlemler Kullanıcı adına yapılmış sayılır.`)
};

const en_kullanim_s4_i3 = /** @type {(inputs: Kullanim_S4_I3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The User is responsible for the confidentiality of the account login details; transactions carried out with these details are deemed to have been made on behalf of the User.`)
};

const de_kullanim_s4_i3 = /** @type {(inputs: Kullanim_S4_I3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der Nutzer ist für die Geheimhaltung der Zugangsdaten verantwortlich; mit diesen Daten vorgenommene Vorgänge gelten als im Namen des Nutzers vorgenommen.`)
};

const ru_kullanim_s4_i3 = /** @type {(inputs: Kullanim_S4_I3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пользователь отвечает за конфиденциальность данных для входа в учётную запись; операции, совершённые с их использованием, считаются совершёнными от имени Пользователя.`)
};

/**
* | output |
* | --- |
* | "The User is responsible for the confidentiality of the account login details; transactions carried out with these details are deemed to have been made on beh..." |
*
* @param {Kullanim_S4_I3Inputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const kullanim_s4_i3 = /** @type {((inputs?: Kullanim_S4_I3Inputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Kullanim_S4_I3Inputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_kullanim_s4_i3(inputs)
	if (locale === "de") return de_kullanim_s4_i3(inputs)
	if (locale === "ru") return ru_kullanim_s4_i3(inputs)
	return tr_kullanim_s4_i3(inputs)
});